<template>
  <div class="order-expiration-list">
    <a-table
        class="order-expiration-list__table"
        :columns="columns"
        :data-source="normalizedOrders"
        :pagination="false"
        :table-layout="'fixed'"
        :custom-row="getRowProps"
        rowKey="id"
        size="small"
    >
      <template #bodyCell="{ column, text, record }">
        <template v-if="column.dataIndex === 'id'">
          <button class="order-expiration-list__order" type="button" @click.stop="openOrder(record.id)">
            {{ text }}
          </button>
        </template>

        <template v-else-if="column.dataIndex === 'expiresAt'">
          <div class="order-expiration-list__date">
            <span>{{ record.expiresAt }}</span>
            <ClockCircleOutlined
                v-if="record.timeRemaining && record.timeRemaining < 30"
                class="circle-clock"
                :style="{ color: '#FAAD14' }"
            />
          </div>
        </template>

        <template v-else-if="column.dataIndex === 'quantity'">
          <span class="order-expiration-list__quantity">{{ text }}</span>
        </template>

        <template v-else>
          {{ text }}
        </template>
      </template>
    </a-table>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ClockCircleOutlined } from '@ant-design/icons-vue';

export default {
  name: 'OrderExpirationListTable',
  components: {
    ClockCircleOutlined,
  },
  props: {
    orders: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();

    const columns = [
      {
        title: 'Заказ',
        dataIndex: 'id',
        key: 'id',
        width: 90,
        align: 'left',
      },
      {
        title: 'Доступно',
        dataIndex: 'quantity',
        key: 'quantity',
        width: 90,
        align: 'right',
      },
      {
        title: 'Истекает',
        dataIndex: 'expiresAt',
        key: 'expiresAt',
        width: 100,
        align: 'right',
      },
    ];

    const normalizedOrders = computed(() =>
        props.orders.map((order) => ({
          id: order.id ?? order.order_id ?? order.orderId,
          quantity: order.not_finished_count ?? 0,
          expiresAt: order.expires_at ?? null,
          timeRemaining: order.remaining_active_days ?? null,
        })).filter((order) => order.id)
    );

    const openOrder = (orderId) => {
      store.commit('relations/setSpecificOrders', [orderId]);
      router.push('/my-orders');
    };

    const getRowProps = (record) => ({
      class: 'order-expiration-list__row',
      onClick: () => openOrder(record.id),
    });

    return {
      columns,
      normalizedOrders,
      getRowProps,
      openOrder,
    };
  },
};
</script>

<style scoped lang="scss">
.order-expiration-list {
  width: 100%;
  max-width: 340px;
}

.order-expiration-list__table {
  width: 100%;
  max-width: 340px;
}

.order-expiration-list  :deep(.ant-table) {
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
}

:deep(.ant-table-container),
:deep(.ant-table-content),
:deep(table) {
  border: 0 !important;
}

.order-expiration-list :deep(.ant-table-thead > tr > th),
.order-expiration-list :deep(.ant-table-tbody > tr > td) {
  padding: 8px 12px !important;
  color: var(--main-font) !important;
}

.order-expiration-list :deep(.ant-table-thead > tr > th) {
  font-weight: 600 !important;
}

:deep(.ant-table-thead > tr > th) {
  font-weight: 600;
  line-height: 110%;
}

:deep(.order-expiration-list__row) {
  cursor: pointer;
}

.order-expiration-list__order {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--main-green);
  cursor: pointer;
}

.order-expiration-list__order:hover {
  color: var(--hover-green);
}

.order-expiration-list__quantity {
  font-weight: 600;
}

.order-expiration-list__date {
  display: flex;
  align-items: center;
  column-gap: 2px;
  flex-direction: row-reverse;
}
</style>

<style lang="scss">
.order-expiration-popover {
  .ant-popover-inner {
    padding: 12px !important;
  }

  .ant-popover-inner-content {
    padding: 0 !important;
  }
}
</style>
